import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import Icon from '../IconDS22';
import styles from './Error.module.scss';

export type ErrorProps = {
  children: ReactNode;
  centered?: boolean;
  showIcon?: boolean;
};

const Error: FC<ErrorProps> = ({ children, centered, showIcon }) => (
  <div className={getClassName(styles, 'root', classNames({ centered }))}>
    {showIcon && <Icon id="warning-filled" size="m" />}
    {children}
  </div>
);

export default Error;
